import { render, staticRenderFns } from "./CryptoAddressListTable.vue?vue&type=template&id=720a66a1&"
import script from "./CryptoAddressListTable.vue?vue&type=script&lang=js&"
export * from "./CryptoAddressListTable.vue?vue&type=script&lang=js&"
import style0 from "./CryptoAddressListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports